<template>
  <div class="experience-page">
    <div class="experience-content">
      <div class="page-header">
        <h1>{{ $t(`app.experience.list.${props.status}.title`) }}</h1>
        <p>{{ $t(`app.experience.list.${props.status}.subtitle`) }}</p>
      </div>

      <template v-if="isPending"></template>

      <div v-else-if="rows.length > 0" class="assessments-table">
        <div class="thead">
          <div>{{ $t('app.experience.list.columns.campaign') }}</div>
          <!-- <div>{{ $t('app.experience.list.columns.job') }}</div> -->
          <div>{{ $t('app.experience.list.columns.invitedAt') }}</div>
          <div>{{ $t(`app.experience.list.${props.status}.stepsColumn`) }}</div>
          <div class="actions">{{ $t('app.experience.list.columns.actions') }}</div>
        </div>
        <div class="tbody">
          <AssessmentRow v-for="assessment in rows" :key="assessment.participant_id" :assessment="assessment" :status="props.status" />
        </div>
      </div>

      <div v-else class="empty-state">
        <div class="empty-icon"><i class="bi bi-folder"></i></div>
        <h2>{{ $t(`app.experience.list.${props.status}.emptyTitle`) }}</h2>
        <p>{{ $t(`app.experience.list.${props.status}.emptyText`) }}</p>
        <Button v-if="props.status === 'started'" class="primary" :label="$t('app.experience.list.seeInvitations')" @click="router.push({ name: 'invitations' })" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCandidateAssessmentsV4 } from '@/queries/assessment.query';
import { AssessmentStatus, getAssessmentStatus } from './assessmentStatus';
import AssessmentRow from './partials/AssessmentRow.vue';

const props = defineProps<{
  status: AssessmentStatus,
}>();

const router = useRouter();

const { data: assessments, isPending } = useCandidateAssessmentsV4();

const rows = computed(() => (assessments.value || []).filter((a) => getAssessmentStatus(a) === props.status));
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";
@import "./experience.scss";

.experience-page {
  //margin: auto 0;
}

.assessments-table {
  background-color: var(--white-color);
  border: 1px solid var(--light-grey-color);
  border-radius: 8px;
  overflow: hidden;

  .thead {
    display: grid;
    grid-template-columns: $experience-table-columns;
    column-gap: 16px;
    align-items: center;
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid var(--light-grey-color);
    font-size: 14px;
    font-weight: 600;

    .actions {
      text-align: right;
    }
  }

  .tbody > :last-child {
    border-bottom: none;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 56px 24px;
  text-align: center;

  background-color: var(--white-color);
  border: 1px dashed var(--light-grey-color);
  border-radius: 8px;

  .empty-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background-color: $primary-100-color;
    color: $primary-900-color;
    font-size: 26px;
  }

  h2 {
    margin: 4px 0 0;
    font-size: 18px;
    font-weight: 700;
  }

  p {
    margin: 0;
    max-width: 460px;
    font-size: 14px;
    line-height: 1.55;
    color: var(--grey-50-color);
  }
}

@media (max-width: 760px) {
  .assessments-table .thead {
    display: none;
  }
}
</style>
